// extracted by mini-css-extract-plugin
export default {"topcont":"platforms_topcont__y7vp-","botcont":"platforms_botcont__7m9Wr","listitems":"platforms_listitems__pPJF4","listitems1":"platforms_listitems1__viWOP"};